import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { SessionContextService } from 'projects/packcert-web/src/app/context/session-context.service';
import { SpinnerService } from 'shared-components';
import { AdminService } from '../../../../services/admin.service';

@Component({
  selector: 'app-new-edit-provincias',
  templateUrl: './new-edit.component.html'
})
export class NewEditProvinciasComponent implements OnInit {

  public provinciasForm: UntypedFormGroup;
  public showError = false;
  public deleteModal = false;
  private _editable: boolean;
  private _toDelete: any;

  get editable(): boolean { return this._editable; }
  @Input() set editable(value: boolean) {
    this._editable = value;
    if (this.provinciasForm) {
      if (value) {
        this.provinciasForm.enable();
      } else {
        this.provinciasForm.disable();
        this.provinciasForm.patchValue(this.provincia);
      }
    }
  };
  @Input() provincia?;
  @Input() id;

  @Output() refresh = new EventEmitter<boolean>();
  @Output() editableChanged = new EventEmitter<any>();
  @Output() pushMessage = new EventEmitter<string>();
  @Output() close = new EventEmitter<boolean>();

  constructor(
    private _fb: UntypedFormBuilder,
    private _adminService: AdminService,
    private readonly _sessionContext: SessionContextService,
    private readonly _spinnerService: SpinnerService
  ) { }

  ngOnInit() {
    this.provinciasForm = this._fb.group({
      des: [{ value: '', disabled: !this.editable }, Validators.required],
    });
    if (this.provincia) {
      this.provinciasForm.patchValue(this.provincia);
    } else {
      this.provinciasForm.enable();
    }
  }

  public get role() {
    return this._sessionContext.sessionUser.role;
  }

  public save(provincia) {
    this.checkForm();
    if (this.provinciasForm.valid) {
      if (this.id != null) {
        const newProvincia = {
          des: this.provinciasForm.get("des").value,
          paisId: this.id
        };
        this._adminService.CreateProvincia(newProvincia).toPromise().finally(() => {
        }).then(() => {
          this.refresh.emit(true);
          this.provinciasForm.disable();
          this.pushMessage.emit('global.success.itemCreated');
        });
      } else {
        const updateProvincia = {
          id: provincia.id,
          des: this.provinciasForm.get("des").value,
          paisId: provincia.paisId
        };
        this._adminService.updateProvincia(updateProvincia).toPromise().finally(() => {
        }).then(() => {
          this.refresh.emit(true);
          this.provinciasForm.disable();
          this.pushMessage.emit('global.success.itemUpdated');
        });
      }
    } else {
      this.showError = true;
    }
  }

  public cancel() {
    if (this.provincia != null) {
      this.refresh.emit();
    } else {
      this.editableChanged.emit();
    }
  }

  public edit(provincia) {
    this.provinciasForm.enable();
    this.editableChanged.emit(provincia);
  }

  public askDelete(provincia) {
    this._toDelete = provincia.id;
    this.deleteModal = true;
  }

  public delete() {
    this._spinnerService.showSpinner();
    this._adminService.deleteProvincia(this._toDelete).toPromise().finally(() => {
    }).then(() => {
      this.closeModal();
      this.refresh.emit(true);
      this.pushMessage.emit('global.success.itemDeleted');
    });
  }

  public closeModal() {
    this.deleteModal = false;
    this._toDelete = '';
  }

  private checkForm() {
    this.showError = this.provinciasForm.invalid;
    if (this.showError) {
      this.pushMessage.emit('global.error.required');
    }
  }

}
